import _ from 'static/script/libs/underscore';
import Storage from 'static/script/app/data/storage-service';

let RecentlyViewedItemsStorage = function(maxNoOfItems) {
    this.maxNoOfItems = maxNoOfItems || 4;
    this._storage = new Storage('recently-viewed-items');
};

RecentlyViewedItemsStorage.prototype.saveItem = function(
    itemId,
    vipUrl,
    imageUrl,
    altText
) {
    this._storage.set(
        itemId,
        JSON.stringify({
            vipUrl: vipUrl,
            imageUrl: imageUrl,
            altText: altText
        })
    );
    this._pruneOldItems();
};

RecentlyViewedItemsStorage.prototype.clearItems = function() {
    let storageItems = this._storage.fetch().orderByTimestamp();
    _.each(
        storageItems,
        function(value) {
            this._storage.remove(value.key);
        },
        this
    );
};

RecentlyViewedItemsStorage.prototype.getAllItems = function() {
    let storageItems = _.first(
        this._storage.fetch().orderByTimestamp(),
        this.maxNoOfItems
    );
    return this._mapStorageToItems(storageItems);
};

RecentlyViewedItemsStorage.prototype._mapStorageToItems = function(
    storageCollection
) {
    function mapStorageToItems(storageItem) {
        let item = JSON.parse(storageItem.value);
        return {
            itemId: storageItem.key,
            vipUrl: item.vipUrl,
            imageUrl: item.imageUrl,
            altText: item.altText
        };
    }
    return _.map(storageCollection, mapStorageToItems);
};

RecentlyViewedItemsStorage.prototype._pruneOldItems = function() {
    let storageItems = this._storage.fetch().orderByTimestamp();
    if (storageItems.length > this.maxNoOfItems) {
        let itemsToRemove = _.last(
            storageItems,
            storageItems.length - this.maxNoOfItems
        );
        _.each(
            itemsToRemove,
            function(value) {
                this._storage.remove(value.key);
            },
            this
        );
    }
};

export default RecentlyViewedItemsStorage;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/recently-viewed-items-storage.js